import { Component, OnInit, ViewChild } from '@angular/core';
import { TipoConteudo as TipoConteudo } from 'src/app/model/arquivo.model';

@Component({
    selector: 'app-recuperacao-credito-lote-pesquisa',
    templateUrl: './recuperacao-credito-lote-pesquisa.component.html',
    standalone: false
})
export class RecuperacaoCreditoLotePesquisaComponent {

  textoBotaoEnvio = 'Enviar arquivo de recuperações de crédito';
  tooltipBotaoEnvio = 'Selecione esta opção para enviar um arquivo com recuperações de crédito';
  tiposConteudo: TipoConteudo[] = [TipoConteudo.RECUPERACOES_CREDITO];
}


